import { modelTypes } from "~/utils";

export type FileType =
  "image" | "text" | "pdf" | "docx" | "3dviewer" | "html" | "markdown" | "xml" | "json" | "csv" | "file";

export const getFileType = (extension?: string, fileName?: string): FileType => {
  const normalizedExtension = extension?.toLowerCase();
  const normalizedFileName = fileName?.toLowerCase();

  if (normalizedExtension === "html" || normalizedExtension === "htm") {
    return "html";
  }

  if (normalizedExtension === "md" || normalizedExtension === "markdown") {
    return "markdown";
  }

  if (normalizedExtension === "xml") {
    return "xml";
  }

  if (normalizedExtension === "json") {
    return "json";
  }

  if (normalizedExtension === "csv") {
    return "csv";
  }

  if (!normalizedExtension && normalizedFileName) {
    if (normalizedFileName.endsWith(".html") || normalizedFileName.endsWith(".htm")) {
      return "html";
    }
    if (normalizedFileName.endsWith(".md") || normalizedFileName.endsWith(".markdown")) {
      return "markdown";
    }
    if (normalizedFileName.endsWith(".json")) {
      return "json";
    }
    if (normalizedFileName.endsWith(".csv")) {
      return "csv";
    }
  }

  if (!normalizedExtension) return "file";

  const modelType = modelTypes[normalizedExtension as keyof typeof modelTypes];
  return (modelType?.type as FileType) || "file";
};
